import React from 'react'
import TextField from '../../../Components/textField/textField'
import CommonButton from '../../../Components/commonButton/commonButton'
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import { Badge } from 'react-bootstrap'
import Slider from '../../../Components/slider/slider'
import Select from '../../../Components/select/select'
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import '../general.css'

export default class AltMachine extends React.Component {
    state = {
        description: "", code: null, work_shifts: [], id_department: 0, shifts: [],
        show: false, message: "", oeeGoal: 0, badge_work_shifts: [], showModal: false,
        departments: [], departments_id: [], show: false, machines: [], machinesAllProperties: [],
        id_work_shift: [], id: 0, selected_department: null, reload: false, is_machine: 0,
        doubleAlert: false,oee_check:false, readOnly: true, notification: false, notification_type: 'success', notification_message: ''
    }

    async componentDidMount() {
        await Api.get('/machines/').then((respo) => {
            let arr = []
            respo.data.forEach(element => {
                arr.push({ value: element.id, label: element.description + element.code })
            });
            this.setState({ machines: arr, machinesAllProperties: [...respo.data] })
        })


        await Api.get('/departments/').then((resp) => {
            let arr = []
            this.setState({ departments_id: [...resp.data] })
            resp.data.forEach(el => {
                arr.push({ value: el.id, label: el.description })
            })
            this.setState({ departments: arr })
        })

        await Api.get('/work-shifts/').then((resp) => {
            let arr = []
            resp.data.forEach(element => {
                arr.push({ value: element.code, label: element.code })
            });
            this.setState({ shifts: arr, work_shifts: [...resp.data] })
        })
    }

    CallbackMachine = (childData) => {
        const { id, description, code, is_machine,andon_double_alert,oee_goal,id_department,work_shifts,oee_check } =
        this.state.machinesAllProperties.find(value => value.id === childData)
        let arrBadge = []
        work_shifts.forEach(value => {
            let { code } = this.state.work_shifts.find(element => element.id === value)
            arrBadge.push(code)
        })
        let result = this.state.departments.filter(e => e.value === id_department)
        this.setState({
            description: description, code: code, oeeGoal: oee_goal, selected_department: result,
            badge_work_shifts: arrBadge, id: id, id_department: id_department, id_work_shift: work_shifts,
            is_machine: is_machine,doubleAlert:andon_double_alert,oee_check:oee_check,readOnly: false
        })
    }

    handleBadge = (e) => {
        let workShift = e.target.title
        const { id } = this.state.work_shifts.find(value => value.code === workShift)
        let result = this.state.id_work_shift.filter(value => value !== id)
        let resultBadge = this.state.badge_work_shifts.filter(value => value !== workShift)
        this.setState({ id_work_shift: result, badge_work_shifts: resultBadge })
    }

    callBackOeeGoal = (child) => { this.setState({ oeeGoal: child }) }
    callBackDepartment = (child) => {
        const result = this.state.departments.find((e) => e.value === child);
        const {value} = result;
        this.setState({ id_department: value, selected_department: result })
    }

    callBackIdWorkShift = (child) => {
        const { id } = this.state.work_shifts.find((e) => e.code === child)
        this.state.id_work_shift.push(id)
        if (this.state.badge_work_shifts.length === 0)
            this.state.badge_work_shifts.push(child)

        if (this.state.badge_work_shifts.length > 0) {
            let code = this.state.badge_work_shifts.find((e) => e === child)
            if (code === undefined)
                this.state.badge_work_shifts.push(child)
        }
        this.forceUpdate();
    }

    sendData = () => {
        if (this.state.id !== 0) {
            if (this.state.id_work_shift.length > 0) {
                if (this.state.oeeGoal > 50) {
                    if((this.state.description !== "" && this.state.description !== null) && (this.state.code !== null && this.state.code !== "") && (this.state.id_department != 0)){
                    Api.put(`/machines/${this.state.id}`, {
                        code: this.state.code,
                        id_department: this.state.id_department,
                        description: this.state.description,
                        id_work_shift: this.state.id_work_shift,
                        is_machine: this.state.is_machine,
                        doubleAlert: this.state.doubleAlert,
                        oee_goal: this.state.oeeGoal,
                        oee_check:this.state.oee_check
                    }).then(() => {
                        this.setState({notification: true, notification_message: "Máquina editada com sucesso!"});
                        setTimeout(()=>{
                            return window.location.reload();
                        },2000)
                    }).catch(err => {
                        this.setState({ show: true, message: "" + err.message })
                    })}
                    else{
                        this.setState({ message: "Verifique se todos os dados foram preenchidos corretamente.", show: true })
                    }
                } else {
                    this.setState({ message: "Defina um valor acima de 50% para a meta de OEE.", show: true })
                }
            } else {
                this.setState({ show: true, message: "Selecione um Turno." })
            }
        } else {
            this.setState({ show: true, message: "Selecione uma Máquina." })
        }
    }

    callbackfunction = () => { this.setState({ show: false }) }
    callBackCode = (child) => { this.setState({ code: child }) }
    callBackDesc = (data) => { this.setState({ description: data }) }
    setCheckDoubleAlert = () => { this.setState({ doubleAlert: !this.state.doubleAlert }) }
    setCheckOEECheck = () => { this.setState({ oee_check: !this.state.oee_check }) }
    setCheckValue = () => { this.setState({ is_machine: !this.state.is_machine }) }

    render() {
        let { show, message, reload, machines, notification, notification_message, notification_type } = this.state
        return (
            <div className="box">
                {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
                <div className="input_fields_add_machine form">
                    <h4>Alterar Máquina</h4>
                    <div className="inputs">

                    {show ? <Alert show={show} reload={reload} message={message} parentCallback={this.callbackfunction} /> : null}
                    <div className='select1AltMachine element'><Select autoSelect={true} label={"Máquinas"}  arrData={machines} handleSelect={this.CallbackMachine} /></div>
                    <div className='tf1AltMachine element'><TextField title="Descrição" max={30} value={this.state.description} validationType="varchar" altType={true} parentCallback={this.callBackDesc} readOnly={this.state.readOnly}/></div>
                    <div className='tf1AltMachine element'  ><TextField section={true} title="Código" max={20} value={this.state.code} validationType="varchar" altType={true} parentCallback={this.callBackCode} readOnly={this.state.readOnly}/></div>
                    <div className="element">
                        <div className='select2AltMachine'  ><Select label="Turno" handleSelect={this.callBackIdWorkShift} arrData={this.state.shifts} /></div>
                        <div className='badgeAltMachine element badge' id='badge2'  >
                            {this.state.badge_work_shifts.map((item, index) => (
                                <div key={index}><Badge title={item} onClick={this.handleBadge} variant="secondary">{item}</Badge></div>))}
                        </div>
                    </div>
                    <div className='select3AltMachine element'  ><Select selectedID={this.state.selected_department} label="Setor" handleSelect={this.callBackDepartment} arrData={this.state.departments} /></div>

                    <div className='sliderAltMachine element slider'><Slider value={this.state.oeeGoal} title={"OEE Meta"} altType={true} parentCallback={this.callBackOeeGoal}></Slider></div>
                    <div className="checkboxs">
                        <div class="form-check element"  >
                            <input class="form-check-input" type="checkbox" checked={this.state.is_machine} id="isMachine" onClick={this.setCheckValue} />
                            <label class="form-check-label" for="isMachine">
                                Apontamento Automático
                            </label>
                        </div>
                        <div class="form-check element"  >
                            <input class="form-check-input" type="checkbox" checked={this.state.doubleAlert}
                                id="doubleAlert" onClick={this.setCheckDoubleAlert} />
                            <label class="form-check-label" for="doubleAlert">
                                Alerta de dois níveis (andon)
                            </label>
                        </div>
                    </div>
                    </div>
                    <div   className="submitButton"><CommonButton which={false} title="Enviar" parentCallback={this.sendData} /></div>
                </div>
            </div>
        )
    }
}